import styled from "styled-components";

export const Layout = styled.div`
  padding: 5rem;
`;
export const InnerLayout = styled.div`
  padding: 4rem 0;
`;

